import React, { useState, useCallback, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";

import Button from "components/CustomButtons/Button";
import Loading from "./Loading";

import toastr from "toastr";

const useStyles = makeStyles(() => ({
  dialogActions: {
    justifyContent: "center"
  },
  menuPaper: {
    maxHeight: 200
  },
  gridContainer: {
    minHeight: 150
  },
  fullWidth: {
    width: "100%"
  },
  downloadFile: {
    cursor: "pointer",
    color: "#c6093b"
  },
  fileUpload: {
    color: "white",
    cursor: "pointer"
  }
}));

export default function FileUploadButton(props) {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [showActions, setShowActions] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [isFileUploading, setIsFileUploading] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    if (props.isUploadSuccess && !props.isError) {
      setIsUploadOpen(false);
      setShowActions(false);
      setSelectedFile([]);
      setIsFileUploading(false);
      toastr.success(props.message ?? "Uploaded successfully");
    } else if (props.isError && !props.isUploadSuccess) {
      setIsUploadOpen(false);
      setShowActions(false);
      setSelectedFile([]);
      setIsFileUploading(false);
    }
  }, [props.isUploadSuccess, props.isError]);

  const handleUpload = async () => {
    setIsFileUploading(true);
    const formData = new FormData();
    formData.append("csvFile", selectedFile, selectedFile.name);
    await props.uploadFile(formData);
  };

  const handleDownload = async () => {
    props.downloadTemplate();
  };

  const handleFileChange = async files => {
    setSelectedFile(files[0]);
    setShowActions(true);
  };

  return (
    <>
      <input
        style={{ display: "none" }}
        type="file"
        accept=".csv"
        id="upload-file-button"
        onChange={async e => {
          await handleFileChange(e.target.files);
        }}
      />
      <Button
        className={classes.fileUpload}
        color="success"
        variant="contained"
        onClick={() => {
          setIsUploadOpen(true);
          setShowActions(false);
          setSelectedFile([]);
        }}
      >
        <div>{"Upload CSV"}</div>
      </Button>
      <Dialog
        open={isUploadOpen}
        fullWidth
        maxWidth="sm"
        onClose={() => {
          setIsUploadOpen(false);
        }}
      >
        <DialogTitle>Upload Member Counts</DialogTitle>
        <DialogContent>
          {isFileUploading ? (
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
              className={classes.gridContainer}
              spacing={2}
            >
              <Loading />
            </Grid>
          ) : (
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
              className={classes.gridContainer}
              spacing={2}
            >
              <Grid item xs={12}>
                <>
                  <Button color="success" variant="contained">
                    <label htmlFor="upload-file-button">
                      <div className={classes.fileUpload}>Select File</div>
                    </label>
                  </Button>
                </>
              </Grid>
              {selectedFile && (
                <Grid item xs={12}>
                  <div>{selectedFile.name}</div>
                </Grid>
              )}
              <Grid item xs={12}>
                <label onClick={handleDownload}>
                  <div className={classes.downloadFile}>Download Sample</div>
                </label>
              </Grid>
              <Grid item xs={12}>
                <label>
                  <div>
                    You can download a sample template or select a file to
                    upload
                  </div>
                </label>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        {showActions && !isFileUploading && (
          <DialogActions classes={{ root: classes.dialogActions }}>
            <Button color="success" variant="contained" onClick={handleUpload}>
              Upload
            </Button>
            <Button
              color="danger"
              variant="contained"
              onClick={() => setIsUploadOpen(false)}
            >
              Cancel
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
}
